import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';
import { IStakeholder, IUpdateStakeholderPayload } from '../../../../interfaces/models/project.model';
import { ProjectService } from '../../../../services/project.service';
import { AuthService } from '../../../../services/auth.service';
import { MultiSelectModule } from 'primeng/multiselect';
import { ToastrService } from 'ngx-toastr';
import { CommonModule } from '@angular/common';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { TranslateModule } from '@ngx-translate/core';
import { DirectionService } from '../../../../services/direction.service';
@Component({
  selector: 'app-stakeholders',
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    InputTextModule,
    DropdownModule,
    MultiSelectModule,
    CommonModule,
    InputTextareaModule,
    TranslateModule
  ],
  templateUrl: './stakeholders.component.html',
  styleUrl: './stakeholders.component.scss'
})
export class StakeholdersComponent implements OnInit {
  stakeholderModel: IStakeholder = this.createEmptyStakeholder();
  dir!: 'rtl' | 'ltr';

  selectedInChargeUnit = {} as any;

  _ProjectsRelations: any;


  @Input({ alias: 'stakeholder' })
  set stakeholderInput(stakeholder: IStakeholder | null | undefined) {
    if (!stakeholder) {
      this.stakeholderModel = this.createEmptyStakeholder();
      return;
    }

    const units = stakeholder.supporting_units ?? [];
    const supporting_units = units.map((unit: any) => {
      if (typeof unit === 'string') {
        return unit;
      }
      return `${unit.type}-${unit.id}`;
    });

    this.stakeholderModel = { ...stakeholder, supporting_units };
  };
  @Input() set ProjectsRelations(value: any) {
    console.log("###ProjectsRelations###", value);
    this.entity_in_charg_options = value['inChargeUnits']
    this.filterd_executive_in_charge_options = value['inChargeUnits'];
    this.executive_in_charge_options = value['inChargeExecutives']
    this.supporting_units_options = value['supportingUnits'];
    console.log("supporting_units_options", this.supporting_units_options);
    this._ProjectsRelations = value;
    this.selectedInChargeUnit = value.inChargeUnits.filter((x: any) => x.is_selected)[0];
  }
  get ProjectsRelations() {
    return this._ProjectsRelations;
  }
  @Input() strategyId!: number;
  @Input() projectId!: number;
  _employees = [] as any[];
  @Input() set employees(value: any) {
    this._employees = value;
    this.filteredEmployees = value;
  };
  get employees() {
    return this._employees;
  }
  filteredEmployees = [] as any[];

  @Output() submitStackholderSuccess = new EventEmitter<IStakeholder>();
  @ViewChild('stakeholdersForm') stakeholdersForm!: FormGroup;
  isSubmitted = false;
  entity_in_charg_options = [] as any[];
  filterd_executive_in_charge_options = [] as any[];
  executive_in_charge_options!: any;
  supporting_units_options!: any;




  constructor(
    private projectService: ProjectService,
    private directionService: DirectionService,
    private toastr: ToastrService,
  ) {
  }
  ngOnInit(): void {
    console.log("stackholllder init");
    this.directionService.direction$.subscribe((dir) => {
      this.dir = dir;
    })
  }

  private createEmptyStakeholder(): IStakeholder {
    return {
      id: 0,
      project_id: this.projectId ?? 0,
      entity_in_charge_id: 0,
      entity_in_charge_type: '',
      executive_in_charge_id: 0,
      supporting_units: [],
      support_in_charge: '',
      partners: '.',
      partners_link_description: '.',
      supporters: '.',
      supporters_link_description: '.',
      created_at: new Date(),
      updated_at: new Date(),
      deleted_at: null as any,
      is_deleted: false,
    };
  }

  onSubmit() {
    this.isSubmitted = true;
    
    // التحقق من أن الوحدات التنظيمية المساندة ليست فارغة
    const supporting_units_value = this.stakeholdersForm.value['supporting_units'];
    if (!supporting_units_value || !Array.isArray(supporting_units_value) || supporting_units_value.length === 0) {
      this.toastr.error(this.dir == 'rtl' ? 'الوحدات التنظيمية المساندة مطلوبة' : 'Supporting units are required');
      return;
    }
    
    if (this.stakeholdersForm.valid) {
      const supporting_units = supporting_units_value.map((value: string) => {
        const [type, id] = value.split("-")
        return { type, id: +id }
      })

      const inChargeUnit = this.selectedInChargeUnit;
      if (!inChargeUnit?.id) {
        this.toastr.error(this.dir == 'rtl' ? 'جهة المبادرة مطلوبة' : 'Initiative owning department is required');
        return;
      }

      const entityInChargeType =
        inChargeUnit.type ??
        inChargeUnit.value?.split('-')[0] ??
        this.stakeholderModel.entity_in_charge_type;

      if (!entityInChargeType) {
        this.toastr.error(this.dir == 'rtl' ? 'نوع جهة المبادرة غير صالح' : 'Invalid initiative owning department type');
        return;
      }
      
      // Fields that backend requires but we want to make optional in frontend
      const optionalFields = ['support_in_charge', 'partners', 'partners_link_description', 'supporters', 'supporters_link_description'];
      const formValues = { ...this.stakeholdersForm.value };
      
      // Replace empty optional fields with "."
      optionalFields.forEach(field => {
        const value = formValues[field];
        const stringValue = value?.toString() || '';
        if (!stringValue || stringValue.trim() === '') {
          formValues[field] = '.';
        }
      });

      const payload: IUpdateStakeholderPayload = {
        id: this.stakeholderModel.id,
        project_id: this.stakeholderModel.project_id || this.projectId,
        entity_in_charge_id: inChargeUnit.id,
        entity_in_charge_type: entityInChargeType,
        executive_in_charge_id: formValues.executive_in_charge_id ?? this.stakeholderModel.executive_in_charge_id,
        supporting_units,
        support_in_charge: formValues.support_in_charge,
        partners: formValues.partners,
        partners_link_description: formValues.partners_link_description,
        supporters: formValues.supporters,
        supporters_link_description: formValues.supporters_link_description,
      };
      
      this.projectService.updateStakeholders(payload,
        this.strategyId, this.stakeholderModel.project_id || this.projectId, this.stakeholderModel.id).subscribe((respone) => {
          const savedStakeholderId = respone?.['data']?.stakeholderId ?? payload.id;
          let stackholder = structuredClone(this.stakeholderModel);
          stackholder.id = savedStakeholderId;
          this.stakeholderModel.id = savedStakeholderId;
          const result = stackholder.supporting_units.map((value: string) => {
            const [type, id] = value.split("-")
            return { id, type }
          })
          stackholder.supporting_units = result;
          this.submitStackholderSuccess.emit(stackholder)
          this.toastr.success(respone['data']['message'])
        })
    } else {
      this.toastr.error(this.dir == 'rtl' ? 'يرجى مراجعة وإكمال البيانات' : 'Please check the data and complete it')
    }
  }

  entityInChargeChange() {
    const [unitType, unitId] = this.selectedInChargeUnit.value.split("-")
    this.filteredEmployees = structuredClone(this.employees).filter((user: any) => {
      return user[`${unitType}_id`] == unitId
    })
  }
}
